import { PuzzleWithSolution } from "../../../../src/components/Eiyuden/Puzzle";
import { Battle as Info } from "../../../../src/components/Battle/Battle";
import React from 'react';
export default {
  PuzzleWithSolution,
  Info,
  React
};